import { render, staticRenderFns } from "./scenceSelect.vue?vue&type=template&id=0315295a&scoped=true"
import script from "./scenceSelect.vue?vue&type=script&lang=js"
export * from "./scenceSelect.vue?vue&type=script&lang=js"
import style0 from "./scenceSelect.vue?vue&type=style&index=0&id=0315295a&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.101.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0315295a",
  null
  
)

export default component.exports